<mat-form-field>
    <mat-label>{{label ?? "Choose a date"}}</mat-label>
    <input #input matInput [matDatepicker]="picker" (focus)="picker.open()" readonly [value]="defaultDate">
    @if (hint) {
<mat-hint>{{hint}}</mat-hint>
}
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker startView="year" (monthSelected)="chosenMonthHandler($event, picker)"
        panelClass="example-month-picker" (closed)="input.blur()">
    </mat-datepicker>
</mat-form-field>